<shared-header [icons]="icons"></shared-header>

<!-- Spheres parallax e icono de whatsapp en orden -->
<spheres-parallax [icons]="icons"></spheres-parallax>

<img class="whatsapp-icon" src="{{ icons.whatsapp }}" alt="" [ngStyle]=" {
          'width': '84px',
          'height': '84.287px',
          'position': 'fixed',
          'right': '48px',
          'bottom': '25px',
          'z-index': 1000,
          'cursor': 'pointer'
  }" (click)="openWhatsApp()">

<div class="bg-gray">
  <div class="max-container-1440">
    <div class="terminos" style="margin-top: 84px; margin-bottom: -72px;">
      <div class="bg-image-1"></div>
      <div class="bg-image-2"></div>
      <div class="contenido-terminos">
        <div class="head-terminos">
          <h1>Términos y condiciones</h1>
          <p class="update">Última actualización: <span>17 de abril de 2026</span></p>
        </div>

        <p class="title">I. INTRODUCCIÓN.</p>
        <p class="text">
          El presente documento establece los Términos y Condiciones que regulan el uso de la página web [<a
            class="link" href="https://dram.capital" target="_blank">https://dram.capital</a>] (en adelante “Sitio
          Web”). El Sitio Web es propiedad y está operado por Dram Capital S.A.P.I. DE C.V. S.O.F.O.M. E.N.R. (en
          adelante “Dram Capital”) Dram Capital da a conocer y pone a su disposición los presentes términos y
          condiciones los cuales tienen como fin regular el uso, navegación, intercambio, manipulación de la
          información, imágenes, consultas y/o cualquier otra clase de contenido que se encuentre a disposición de los
          Usuarios a través del Sitio Web.
          <br><br>
          Al acceder y/o utilizar cualquier parte del Sitio Web el usuario se obliga y sujeta incondicionalmente a lo
          dispuesto en los presentes Términos y Condiciones, así como a cualquier documento, publicación o información
          que los complemente, adicione o modifique, de conformidad con la legislación y demás normatividad aplicable
          relacionada directa o indirectamente con los servicios que Dram Capital ofrece.
          <br><br>
          El Usuario deberá tener en cuenta que algunos de los Servicios que Dram Capital ofrece tienen condiciones y
          obligaciones adicionales, por lo que su uso estará complementado con lo dispuesto en los Términos y
          Condiciones Específicos que establezca Dram Capital. Además, Dram Capital ha publicado un Aviso de Privacidad
          para clientes y prospectos en <a class="link" href="https://dram.capital/aviso-privacidad"
            target="_blank">https://dram.capital/aviso-privacidad</a> que el Usuario debe asegurarse para entender el
          uso del tratamiento de la información del Usuario por parte de Dram Capital. Cualquier persona que no acepte
          estos Términos y Condiciones Generales, así como el Aviso de Privacidad de Dram Capital, los cuales tienen un
          carácter de obligatorio y vinculante deberá abstenerse de utilizar los Servicios Dram Capital, su Sitio Web
          y/o Plataforma.
          <br><br>
          Dram Capital se reserva el derecho de modificar los presentes Términos y Condiciones en cualquier momento y
          sin previo aviso. Las modificaciones entraran en vigor a los 5 (cinco) días naturales siguientes a su
          publicación en el Sitio Web, plazo durante el cual el Usuario podrá manifestar su inconformidad conforme a lo
          establecido en la Sección XII.
          <br><br>
          El usuario puede revisar la versión actualizada de los Términos de Servicio en cualquier momento en la
          presente página.
        </p>

        <p class="title">II. DEFINICIONES.</p>
        <p class="text">
          Para efectos de los presentes Términos y Condiciones los siguientes términos tendrán el significado que se les
          atribuye a continuación, salvo que en el contexto se indique lo contrario:
        </p>
        <div class="list">
          <div class="item-list">
            <p class="text">A)</p>
            <p class="text"><b>CONTRAPRESTACIÓN</b>: Cargos, comisiones, pagos o tarifas que el Usuario debe cubrir por
              el acceso y uso de los servicios de Dram Capital, según lo establecido en los Términos y Condiciones
              Específicos.</p>
          </div>
          <div class="item-list">
            <p class="text">B)</p>
            <p class="text"><b>SERVICIOS</b>: productos, herramientas, aplicaciones o servicios ofrecidos por Dram
              Capital a través de su Sitio Web, incluyendo aquellos que requieran una contraprestación.</p>
          </div>
          <div class="item-list">
            <p class="text">C)</p>
            <p class="text"><b>SITIO WEB</b>: Página web, plataformas digitales, aplicaciones móviles u otros medios
              electrónicos operados por Dram Capital, a través de los cuales los Usuarios pueden acceder a los
              Servicios.</p>
          </div>
          <div class="item-list">
            <p class="text">D)</p>
            <p class="text"><b>TÉRMINOS PARTICULARES</b>: conjunto de documentos que rigen en particular los servicios
              ofrecidos por Dram Capital, los cuales detallan las características, costos, responsabilidades y demás
              condiciones inherentes al servicio contratado.</p>
          </div>
          <div class="item-list">
            <p class="text">E)</p>
            <p class="text"><b>USUARIO</b>: Persona física o moral que accede al Sitio Web o utiliza los Servicios de
              Dram Capital.</p>
          </div>
        </div>

        <p class="title">III. MANIFESTACIONES Y DATOS DE USUARIO.</p>
        <p class="text">
          El Usuario manifiesta ser mayor de edad y encontrarse en pleno uso y goce de sus facultades y derechos, por lo
          que no tiene impedimento legal para suscribir los presentes términos de uso.<br>
          Para el caso de Usuarios que sean personas morales, la persona que lleve a cabo el registro y acceso en las
          Aplicaciones, Sitio Web y/o Plataformas de Dram Capital deberá contar con la representación legal
          correspondiente y facultades suficientes para actos de administración, conforme al segundo párrafo del
          artículo 2554 del Código Civil Federal y el artículo 2° del Código de Comercio, debidamente otorgadas ante
          fedatario público.
          <br><br>
          La persona que realice el registro y/o utilice el Sitio Web y/o Plataforma de Dram Capital en representación
          de una persona moral declara bajo protesta de decir verdad que cuenta con las facultades necesarias para
          actuar en nombre y por cuenta de ésta. Asimismo, manifiesta que dicha persona moral acepta adherirse a los
          presentes Términos y Condiciones Generales y, en su caso, a los Términos y Condiciones Específicos aplicables.
          <br><br>
          Dram Capital podrá suspender o cancelar el acceso del Usuario cuando: (i) se detecte información falsa o
          documentación alterada; (ii) exista incumplimiento de pago; (iii) se identifique uso indebido o actividad
          ilícita; o (iv) así lo exija una autoridad competente. En dichos casos, se notificará al Usuario por correo
          electrónico registrado con al menos 48 horas de anticipación, salvo que la urgencia o riesgo de fraude
          justifique la cancelación inmediata.
          <br><br>
          Asimismo, el Usuario declara bajo protesta de decir verdad que los datos personales y/o documentos que ha
          proporcionado para su identificación y registro en los casos así requeridos en el Sitio son de su titularidad,
          auténticos y verificables por las autoridades competentes que conforme a derecho así lo requieran. Para más
          información acerca de los datos requeridos y sus tratamientos el usuario puede consultar el Aviso de
          Privacidad correspondiente.
          <br><br>
          El usuario será el único responsable de la adecuada custodia de sus datos, información de identificación,
          FIEL, clave privada y demás elementos de identidad necesarios para utilizar los servicios ofrecidos por Dram
          Capital, así como de mantenerlos vigentes y actualizados.
          <br><br>
          Para utilizar la totalidad o parte de los servicios de Dram Capital, el usuario deberá crear una cuenta. Su
          nombre de usuario y contraseña son exclusivamente para su uso personal y deberán mantenerse confidenciales. El
          usuario es responsable de todo mal uso de su nombre de usuario y contraseña, incluido cualquier uso no
          autorizado. Deberá notificar inmediatamente al equipo de Atención al Cliente de Dram Capital si pierde o le
          roban su nombre de usuario o contraseña, o si considera que ha habido un acceso no autorizado a su cuenta.
          <br><br>
          El Usuario reconoce y acepta que solo podrá utilizar el Sitio Web y/o Plataforma y los servicios contratados
          por conducto de esta para fines lícitos, en estricto cumplimiento de la legislación mexicana aplicable y de
          los presentes Términos y Condiciones. Por lo tanto, acepta que Dram Capital y/o los Terceros Relacionados
          podrán rechazar o cancelar cualquier solicitud de servicio, o servicio en curso, o bien cancelar o dejar sin
          efectos las conficiones acordadas, sin responsabilidad alguna, en caso de que se detecte información falsa,
          documentación alterada o la posibilidad de que los servicios contratados pudieran utilizarse para fines
          ilícitos.
        </p>

        <p class="title">IV. CONSULTAS PREVIAS.</p>
        <p class="text">
          Para la contratación de los Servicios Dram Capital, así como de cualquier otro producto o servicio que esta
          ofrezca, el Usuario acepta y reconoce que Dram Capital podrá realizar consultas, análisis y revisiones de
          indicadores que considere necesarios para evaluar el comportamiento crediticio del posible Usuario y minimizar
          el riesgo de fraude.
          <br><br>
          Dram Capital se reserva el derecho de solicitar comprobantes o información adicional con el propósito de
          verificar los Datos de Registro proporcionados por los Usuarios. Asimismo, podrá suspender de manera temporal
          o definitiva los Servicios de Dram Capital a aquellos Usuarios cuya información no pueda ser validada.
          <br><br>
          Dram Capital también se reserva el derecho de rechazar solicitudes de registro, así como de cancelar o
          suspender, temporal o definitivamente, los Servicios en caso de detectar inconsistencias en la información
          proporcionada o actividades sospechosas. Estas decisiones no generarán para los Usuarios derecho a
          indemnización o compensación alguna.
        </p>

        <p class="title">V. CONSULTA DE REPORTES E INFORMACION.</p>
        <p class="text">
          El Usuario autoriza a Dram Capital, a través de sus funcionarios facultados, para realizar investigaciones
          sobre su comportamiento crediticio en Círculo de Crédito, S.A. de C.V., SIC, o en cualquier otra Sociedad de
          Información Crediticia. En este sentido, Dram Capital podrá consultar periódicamente el historial crediticio
          del Usuario, así como la información contenida en los reportes de crédito y reportes de crédito especial.
          <br><br>
          La autorización para consultar el historial crediticio permanecerá vigente durante la relación contractual con
          Dram Capital y hasta por 1 (un) año posterior a su terminación, salvo que existan adeudos pendientes, en cuyo
          caso se extenderá hasta su liquidación total. El Usuario podrá revocar esta autorización una vez que no exista
          relación jurídica vigente con Dram Capital, siguiendo el procedimiento del Aviso de Privacidad.
          <br><br>
          La autorización mencionada continuará vigente incluso tras la cancelación del servicio con Dram Capital, y
          solo podrá ser revocada si el Usuario no tiene relación jurídica alguna con Dram Capital. La revocación deberá
          realizarse conforme al procedimiento establecido en el Aviso de Privacidad para clientes y prospectos,
          específicamente en la sección “Ejercicio de Derechos: Acceso, Rectificación, Cancelación, Oposición y
          Revocación del Consentimiento”.
        </p>

        <p class="title">VI. DEVOLUCIONES Y CANCELACIONES.</p>
        <p class="text">
          Como regla general, los pagos realizados no serán reembolsables. Sin embargo, Dram Capital podrá analizar
          solicitudes de devolución en los siguientes supuestos: (i) falla técnica comprobable imputable a Dram Capital
          que impidiera el uso del servicio por más de 72 horas continuas; o (ii) cobro duplicado por error del sistema.
          Las solicitudes deberán presentarse dentro de los 10 días naturales siguientes al cargo, a través del correo
          de atención al cliente.
        </p>

        <p class="title">VII. PAGOS Y FACTURACIÓN.</p>
        <p class="text">
          La navegación en el Sitio Web será a título gratuito para el Usuario. Sin embargo, el Usuario acepta y
          reconoce que el acceso a los Servicios ofrecidos por Dram Capital generarán el pago de una contraprestación.
          El monto de dicha contraprestación dependerá del tipo de Servicio contratado, conforme a los Términos y
          Condiciones aplicables a cada servicio.
          <br><br>
          En caso de que los Servicios incluyan diferentes modalidades o planes, la selección de la modalidad o plan
          será responsabilidad exclusiva del Usuario. Los cargos, comisiones o pagos correspondientes a la
          contraprestación por el uso de los Servicios se realizarán de forma única, mensual o anual, dependiendo del
          tipo de servicio, así como de la modalidad o plan elegido por el Usuario. El Usuario podrá consultar en sus
          Términos Particulares correspondiente la información relativa a la modalidad o plan contratado, la fecha de
          corte y el historial de pagos realizados.
          <br><br>
          Los pagos se efectuarán a través de la plataforma Stripe Payments México S de R.L. de C.V. ("Stripe"). Dram
          Capital realizará los cargos a la tarjeta de débito o crédito del Usuario mediante Stripe, previa
          autorización, por los Servicios contratados por el usuario. El Usuario reconoce y acepta que Stripe se reserva
          el derecho de declinar una transacción por cualquier motivo, y que, en tal caso, ni Stripe ni Dram Capital
          serán responsables de los pagos declinados.
          <br><br>
          Todos los pagos procesados a través de Stripe implican que la captura de información de la tarjeta de crédito
          o débito del Usuario se realiza en la plataforma y servidores de Stripe, siguiendo sus propios estándares de
          seguridad. Al utilizar el Sitio, el Usuario reconoce y acepta sin reservas los Términos y Condiciones, así
          como el Aviso de Privacidad de Stripe, exonerando a Dram Capital de cualquier responsabilidad y reclamación
          relacionada con el manejo de su información.
          <br><br>
          Dram Capital se reserva el derecho de negar los servicios contratados por el usuario si no se ha realizado el
          pago o no se ha reflejado en su cuenta bancaria.
          <br><br>
          Dram Capital se reserva el derecho de modificar o actualizar los cargos aplicables a sus Servicios para
          contrataciones futuras, incluyendo, sin limitarse a, tasas de interés, comisiones y demás conceptos
          aplicables.
          <br><br>
          Dichas modificaciones no afectarán las condiciones previamente pactadas en contratos de crédito vigentes,
          salvo que exista disposición expresa en el contrato correspondiente y en cumplimiento con la normativa
          aplicable.
          <br><br>
          Cualquier modificación será notificada al Usuario con al menos 15 (quince) días naturales de anticipación a
          través del correo electrónico registrado.
          <br><br>
          Si el Usuario no manifiesta su inconformidad antes de la fecha de entrada en vigor del nuevo precio, se
          entenderá que acepta el ajuste. En caso de inconformidad, el Usuario podrá cancelar su suscripción conforme al
          procedimiento establecido en la Sección XIV.
        </p>

        <p class="title">VIII. LIMITACIÓN DE RESPONSABILIDAD.</p>
        <p class="text">
          Dram Capital no será responsable por: (i) daños indirectos, incidentales o consecuentes derivados del uso o
          imposibilidad de uso del Sitio; (ii) interrupciones del servicio causadas por terceros, caso fortuito o fuerza
          mayor; (iii) decisiones financieras tomadas por el Usuario basadas en información contenida en el Sitio. Dram
          Capital sí responderá por daños directos y comprobables causados por negligencia grave de su personal o fallas
          técnicas atribuibles exclusivamente a la plataforma.
          <br><br>
          El Usuario deberá dejar en paz y a salvo a Dram Capital, sus accionistas, afiliadas, directores, gerentes,
          empleados, asesores, abogados, representantes y/o cualquier otra persona relacionada con Dram Capital, de
          cualquier responsabilidad que pudiera imputársele, por virtud y/o con relación al Sitio, así como por los
          servicios que se presenten y los documentos que se pongan a disposición del Usuario.
        </p>

        <p class="title">IX. OTROS SERVICIOS.</p>
        <p class="text">
          Por otro lado, los usuarios pueden solicitar servicios jurídicos adicionales, tales como asesorías jurídicas,
          elaboración de contratos especializados, presentación de declaración de uso ante el IMPI, entre otros. Para
          solicitar dichos servicios adicionales, el Usuario deberá ponerse en contacto con atención al cliente para la
          debida cotización.
        </p>

        <p class="title">X. PROPIEDAD INTELECTUAL</p>
        <p class="text">
          El Usuario reconoce que la Propiedad Intelectual, consistente en El Sitio Web en sí mismo y todo el contenido
          e información que se muestran a través de éste, son propiedad de Dram Capital y/o de sus legítimos titulares o
          licenciatarios.
          <br><br>
          El Usuario reconoce a Dram Capital como el único y exclusivo propietario de la Propiedad Intelectual, ya esté
          debidamente registrada a su favor o no, y se obliga a no hacer mal uso, ni un uso no autorizado de la misma, a
          no ostentarse como su titular y/o licenciatario, y a no disputar dicha titularidad con Dram Capital.
          <br><br>
          Se prohíbe expresamente al Usuario utilizar, modificar, alterar o suprimir, ya sea en forma total o parcial,
          la Propiedad Intelectual contenida en el Sitio Web para fines distintos a los establecidos en estos Términos y
          Condiciones. El Usuario no copiará, traducirá, ni creará o intentará crear, mediante técnicas de ingeniería
          inversa o de cualquier otra manera, el código fuente del Sitio Web. El Usuario no está autorizado a realizar
          trabajos derivados del Sitio Web y, en su caso, la propiedad de cualquiera de los trabajos derivados no
          autorizados se concederá a Dram Capital.
          <br><br>
          El Usuario reconoce y acepta que la Propiedad Intelectual de Dram Capital relativa al Sitio Web, su
          funcionamiento y/o contenido, no necesariamente es de dominio público, ni resulta evidente para un técnico en
          la materia, sino que tiene una aplicación industrial o comercial que le significa a Dram Capital obtener o
          mantener una ventaja competitiva o económica frente a terceros en la realización de actividades comerciales, y
          respecto de la cual ha adoptado los medios o sistemas suficientes para preservar su confidencialidad y el
          acceso restringido a la misma. Por lo tanto, cualquier vulneración de seguridad a la Propiedad Intelectual o
          información confidencial de Dram Capital constituye una conducta ilícita, perseguida y castigada por las leyes
          correspondientes.
        </p>

        <p class="title">XI. JURISDICCIÓN Y LEGISLACIÓN APLICABLE.</p>
        <p class="text">
          Para la interpretación, cumplimiento y ejecución del presente acuerdo, las partes convienen que serán
          aplicables las leyes vigentes y relacionadas de los Estados Unidos Mexicanos, será interpretado conforme a la
          legislación aplicable de carácter mercantil, civil, propiedad intelectual, protección de datos personales o
          cualquier otra materia, bajo la jurisdicción y competencia de los Tribunales respectivos por cuestión de la
          materia del Primer Partido Judicial del Estado de Jalisco, renunciando a cualquier otra jurisdicción que les
          pudiera corresponder en función de sus domicilios presentes o futuros, o por cualquier otra razón.
        </p>

        <p class="title">XII. MODIFICACIONES.</p>
        <p class="text">
          El Usuario tendrá un plazo de 5 (cinco) días naturales, contados a partir de la publicación de los cambios,
          para manifestar su negativa mediante correo electrónico a Dram Capital. En caso de expresar su negativa, se
          cancelará su registro como Usuario y se inhabilitará su acceso a los Sitios Web y/o Plataformas de Dram
          Capital. No obstante, el Usuario estará obligado a liquidar cualquier monto pendiente derivado de la
          contratación de los Servicios de Dram Capital.
          <br><br>
          Si el Usuario no comunica su oposición dentro del plazo señalado, se considerará que acepta los nuevos
          términos y condiciones.
        </p>

        <p class="title">XIII. DUDAS, COMENTARIOS Y SUGERENCIAS.</p>
        <p class="text">
          El Usuario puede contactar al personal de Dram Capital en cualquier momento para resolver dudas, hacer
          comentarios o solicitar aclaraciones relacionadas con los servicios ofrecidos por Dram Capital, la información
          y documentación disponible en el Sitio, los avisos y notificaciones dirigidos a los usuarios, así como lo
          contenido en los presentes Términos y Condiciones. Estas consultas podrán realizarse a través de los distintos
          canales que Dram Capital habilite para tal fin y que serán anunciados periódicamente o a través de la
          siguiente dirección de correo electrónico: <a href="mailto:contacto@dram.capital"
            class="link">contacto@dram.capital</a>
        </p>

        <p class="title">XIV. CANCELACIÓN A SOLICITUD DEL USUARIO</p>
        <p class="text">
          El Usuario podrá solicitar la cancelación del Servicio en cualquier momento y sin necesidad de expresar causa,
          mediante cualquiera de los siguientes canales:
          <br><br>
          (i) Correo electrónico dirigido al área de Atención al Cliente de Dram Capital; o
          <br><br>
          (ii) A través de la sección "Mi Cuenta" dentro de la Plataforma de Dram Capital.
          <br><br>
          La cancelación surtirá efectos a partir de la fecha en que Dram Capital acuse recibo de la solicitud correspondiente,
          sin perjuicio de las obligaciones de pago que hubieren sido generadas con anterioridad a dicha fecha.
          <br><br>
          Una vez procesada la cancelación y liquidados los adeudos correspondientes, Dram Capital confirmará la baja del
          Usuario mediante notificación al correo electrónico registrado en la Plataforma.
        </p>
      </div>
    </div>
  </div>
</div>

<dram-footer></dram-footer>
